import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { FirstDeploymentNoteDialogData } from '@app/shared/components/dialogs/first-deployment-note-dialog/first-deployment-note-dialog.data';

@Component({
    selector : 'first-deployment-note-dialog',
    template: require('./first-deployment-note-dialog.component.html'),
    styles: [require('./first-deployment-note-dialog.component.scss')]
})
export class FirstDeploymentNoteDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: FirstDeploymentNoteDialogData) {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/first-deployment-note-dialog/first-deployment-note-dialog.component.ts